import angular from 'angular';

angular
  .module('cloudX')
  .controller('RelationsUsingTaskPeriodicityDialogCtrl', [
    '$scope',
    'appMessages',
    'close',
    'relations',
    relationsUsingTaskPeriodicityDialogCtrl,
  ]);

function relationsUsingTaskPeriodicityDialogCtrl($scope, appMessages, close, relations) {
  $scope.relations = relations;
  $scope.close = function(result) {
    close(result, 500);
  };
}
